import React from 'react';
import { icons } from '@ublend-npm/aulaui-next';

import { Provider, isKnownProvider } from './assignmentType';
import { EmptyLogoSpace } from './ProviderLogo.styled';

const providerToLogo = {
  [Provider.Handin]: icons.Handin,
  [Provider.Manual]: icons.SSA,
  [Provider.TurnitIn]: icons.TurnitIn,
  [Provider.Quizzes]: icons.Quiz,
};

export const ProviderLogo = ({ provider }: { provider: string }) => {
  if (!isKnownProvider(provider)) {
    return <EmptyLogoSpace data-testid="empty-logo" />;
  }

  const Logo = providerToLogo[provider];
  return <Logo />;
};
